import { guardedClient as clientRequest } from '@repo/shared/helpers';
import { TemplateApiResponse, templateApiResponseSchema, Template, templateSchema } from '@repo/shared/domain';

export interface Config {
	configId: string;
	name: string;
	owner: string;
	createdAt: string;
	updatedAt: string;
}

export interface SystemStatus {
	version: string;
}

// System Status
export const getSystemStatus = async (): Promise<SystemStatus> => {
	try {
		const { body } = await clientRequest.get<undefined, SystemStatus>('/api/system/status', { schema: undefined });
		return body;
	} catch (error) {
		console.error('Failed to get system status:', error);
		return { version: 'unknown' };
	}
};

// Configs
export const getConfigs = async (): Promise<Config[]> => {
	try {
		const { body } = await clientRequest.get<undefined, { results: Config[] }>('/api/system/configs', {
			schema: undefined,
		});
		return body?.results || [];
	} catch (error) {
		console.error('Failed to get configs:', error);
		return [];
	}
};

export const getCurrentConfig = async (): Promise<{ settings: Record<string, unknown> }> => {
	try {
		const { body } = await clientRequest.get('/api/system/configs/current', { schema: undefined });
		return body as { settings: Record<string, unknown> };
	} catch (error) {
		console.error('Failed to get current config:', error);
		return { settings: {} };
	}
};

export const saveConfig = async (config: { name: string; owner: string; config: Record<string, unknown> }) => {
	const { body } = await clientRequest.post('/api/system/configs', config);
	return body;
};

export const loadConfig = async (configId: string) => {
	const { body } = await clientRequest.post('/api/system/configs/load', { configId });
	return body;
};

export const deleteConfig = async (configId: string) => {
	return clientRequest.del(`/api/system/configs/${configId}`);
};

// Templates
export const getTemplates = async (): Promise<TemplateApiResponse> => {
	const { body } = await clientRequest.get('/api/settings/templates', {
		schema: templateApiResponseSchema,
	});
	return body;
};

export const getTemplate = async (id: string): Promise<Template> => {
	const { body } = await clientRequest.get(`/api/settings/templates/${id}`, {
		schema: templateSchema,
	});
	return body;
};

export const updateTemplate = async (id: string, template: string): Promise<void> => {
	return clientRequest.put(`/api/settings/templates/${id}`, { template });
};

export const resetTemplate = async (id: string): Promise<void> => {
	return clientRequest.post(`/api/settings/templates/${id}/reset`, {});
};

// Import
export const importUsers = async (data: Record<string, unknown>): Promise<void> => {
	return clientRequest.post('/api/system/import-users', data);
};

export const importBlocklist = async (data: Record<string, unknown>): Promise<void> => {
	return clientRequest.post('/api/system/import-blocklist', data);
};
